import React, { Fragment } from 'react';

import Select, { components, MenuProps } from 'react-select';
import AsyncSelect from 'react-select/async';
import { Form } from 'react-bootstrap';
import Required from '../Required';
import SelectInput from '../SelectInput/SelectInput';

function SelectWithCustomInput({
  value, placeholder, defaultOptions, defaultValue, loadOptions, onInputChange, onChange, classNamePrefix, label, required, disabled = false,
}) {
  const getLength = (options) => options.reduce((acc, curr) => {
    if ('options' in curr) return acc + getLength(curr.options);
    return acc + 1;
  }, 0);

  // eslint-disable-next-line react/no-unstable-nested-components
  function Menu(props) {
    const optionsLength = getLength(props.options);
    return (
      <components.Menu
        {...props}
      >
        {optionsLength ? props.children : <div />}
      </components.Menu>
    );
  }
  return (
    <>
      <Form.Label style={{ color: '#7F7F7F' }}>
        {label}
        {' '}
        {required && <Required />}
      </Form.Label>
      <SelectInput
        disabled={disabled}
        isClearable
        classNamePrefix={classNamePrefix}
        cacheOptions
        components={{ Menu, DropdownIndicator: () => null, IndicatorSeparator: () => null }}
        value={value}
        placeholder={placeholder}
            // value={value ?? ' 1'}
        defaultOptions={defaultOptions}
        defaultValue={defaultValue}
        loadOptions={loadOptions}
        onInputChange={(selectedValue, { action }) => {
          if (action !== 'menu-close' && action !== 'input-blur') {
            return onInputChange(selectedValue);
          }
          if (action === 'menu-close' && action === 'input-blur' && (!value?.label?.length || value?.label?.length === 0)) {
            value = null;
          }
        }}
        onChange={onChange}
      />
    </>
  );
}

export default SelectWithCustomInput;
